// Import de funcions auxiliars
import {
    obteVariable,
    obteValorVariable,
    afegeixErrorAVariable
}  from './utils';

/*
 * Per facilitar la lectura del codi s'afegeixen els identificadors de variables a mode de constants
 ***/
// De 00 a 07h
export const ID_METEORS_DE_PRECIPITACIO_OBSERVATS_ENTRE_00_I_07H = 62;
export const ID_GRUIX_DE_NEU_AL_TERRA_ENTRE_00_I_07H = 63;
export const ID_DIAMETRE_DE_LA_PEDRA_ENTRE_00_I_07H = 64;

// De 07 a 13h
export const ID_METEORS_DE_PRECIPITACIO_OBSERVATS_ENTRE_07_I_13H = 67;
export const ID_GRUIX_DE_NEU_AL_TERRA_ENTRE_07_I_13H = 68;
export const ID_DIAMETRE_DE_LA_PEDRA_ENTRE_07_I_13H = 69;

// De 13 a 18h
export const ID_METEORS_DE_PRECIPITACIO_OBSERVATS_ENTRE_13_I_18H = 72;
export const ID_GRUIX_DE_NEU_AL_TERRA_ENTRE_13_I_18H = 73;
export const ID_DIAMETRE_DE_LA_PEDRA_ENTRE_13_I_18H = 74;

// De 18 a 24h
export const ID_METEORS_DE_PRECIPITACIO_OBSERVATS_ENTRE_18_I_24H = 77;
export const ID_GRUIX_DE_NEU_AL_TERRA_ENTRE_18_I_24H = 78;
export const ID_DIAMETRE_DE_LA_PEDRA_ENTRE_18_I_24H = 79;

/*
 * Objectes auxiliars amb les llistes dels possibles valors seleccionables a les variables de:
 *  - Meteors de precipitació
 ***/
export const meteorPedraEntre00i07h = {
    nom: 'Pedra (Pd)',
    valor: '110'
};

export const meteorNeuSobreTerraEntre00i07h = {
    nom: 'Neu sobre el terra (Nt)',
    valor: '115'
};

export const meteorPedraEntre07i13h = {
    nom: 'Pedra (Pd)',
    valor: '122'
};

export const meteorNeuSobreTerraEntre07i13h = {
    nom: 'Neu sobre el terra (Nt)',
    valor: '127'
};

export const meteorPedraEntre13i18h = {
    nom: 'Pedra (Pd)',
    valor: '134'
};

export const meteorNeuSobreTerraEntre13i18h = {
    nom: 'Neu sobre el terra (Nt)',
    valor: '139'
};

export const meteorPedraEntre18i24h = {
    nom: 'Pedra (Pd)',
    valor: '146'
};

export const meteorNeuSobreTerraEntre18i24h = {
    nom: 'Neu sobre el terra (Nt)',
    valor: '151'
};

/*
 * Noms dels diferents valors de cadascuna de les llistes desplegables que s'utilitzaran
 ***/
export const NOM_GRUIX_DE_NEU_AL_TERRA_ENTRE_00_I_07H = 'Gruix de neu al terra entre 00 i 07h';
export const NOM_DIAMETRE_DE_LA_PEDRA_ENTRE_00_I_07H = 'Diàmetre de la pedra entre 00 i 07h';
export const NOM_GRUIX_DE_NEU_AL_TERRA_ENTRE_07_I_13H = 'Gruix de neu al terra entre 07 i 13h';
export const NOM_DIAMETRE_DE_LA_PEDRA_ENTRE_07_I_13H = 'Diàmetre de la pedra entre 07 i 13h';
export const NOM_GRUIX_DE_NEU_AL_TERRA_ENTRE_13_I_18H = 'Gruix de neu al terra entre 13 i 18h';
export const NOM_DIAMETRE_DE_LA_PEDRA_ENTRE_13_I_18H = 'Diàmetre de la pedra entre 13 i 18h';
export const NOM_GRUIX_DE_NEU_AL_TERRA_ENTRE_18_I_24H = 'Gruix de neu al terra entre 18 i 24h';
export const NOM_DIAMETRE_DE_LA_PEDRA_ENTRE_18_I_24H = 'Diàmetre de la pedra entre 18 i 24h';

/*
 * Missatges d'error propis del grup
 ***/
export const MSG_SI_NEU_SOBRE_TERRA_ALESHORES_GRUIX_DE_NEU_ENTRE_00_I_07H = `Si se selecciona el meteor de precipitació "${meteorNeuSobreTerraEntre00i07h.nom}" entre les 00 i les 07h al grup "Temps passat", cal informar la variable "${NOM_GRUIX_DE_NEU_AL_TERRA_ENTRE_00_I_07H}" al grup "Neu".`;
export const MSG_SI_NEU_SOBRE_TERRA_ALESHORES_GRUIX_DE_NEU_ENTRE_07_I_13H = `Si se selecciona el meteor de precipitació "${meteorNeuSobreTerraEntre07i13h.nom}" entre les 07 i les 13h al grup "Temps passat", cal informar la variable "${NOM_GRUIX_DE_NEU_AL_TERRA_ENTRE_07_I_13H}" al grup "Neu".`;
export const MSG_SI_NEU_SOBRE_TERRA_ALESHORES_GRUIX_DE_NEU_ENTRE_13_I_18H = `Si se selecciona el meteor de precipitació "${meteorNeuSobreTerraEntre13i18h.nom}" entre les 13 i les 18h al grup "Temps passat", cal informar la variable "${NOM_GRUIX_DE_NEU_AL_TERRA_ENTRE_13_I_18H}" al grup "Neu".`;
export const MSG_SI_NEU_SOBRE_TERRA_ALESHORES_GRUIX_DE_NEU_ENTRE_18_I_24H = `Si se selecciona el meteor de precipitació "${meteorNeuSobreTerraEntre18i24h.nom}" entre les 18 i les 24h al grup "Temps passat", cal informar la variable "${NOM_GRUIX_DE_NEU_AL_TERRA_ENTRE_18_I_24H}" al grup "Neu".`;

export const MSG_SI_GRUIX_DE_NEU_ALESHORES_NEU_SOBRE_TERRA_ENTRE_00_I_07H = `Si s'informa la variable "${NOM_GRUIX_DE_NEU_AL_TERRA_ENTRE_00_I_07H}" al grup "Neu", cal informar el meteor de precipitació "${meteorNeuSobreTerraEntre00i07h.nom}" entre les 00 i les 07h al grup "Temps passat".`;
export const MSG_SI_GRUIX_DE_NEU_ALESHORES_NEU_SOBRE_TERRA_ENTRE_07_I_13H = `Si s'informa la variable "${NOM_GRUIX_DE_NEU_AL_TERRA_ENTRE_07_I_13H}" al grup "Neu", cal informar el meteor de precipitació "${meteorNeuSobreTerraEntre07i13h.nom}" entre les 07 i les 13h al grup "Temps passat".`;
export const MSG_SI_GRUIX_DE_NEU_ALESHORES_NEU_SOBRE_TERRA_ENTRE_13_I_18H = `Si s'informa la variable "${NOM_GRUIX_DE_NEU_AL_TERRA_ENTRE_13_I_18H}" al grup "Neu", cal informar el meteor de precipitació "${meteorNeuSobreTerraEntre13i18h.nom}" entre les 13 i les 18h al grup "Temps passat".`;
export const MSG_SI_GRUIX_DE_NEU_ALESHORES_NEU_SOBRE_TERRA_ENTRE_18_I_24H = `Si s'informa la variable "${NOM_GRUIX_DE_NEU_AL_TERRA_ENTRE_18_I_24H}" al grup "Neu", cal informar el meteor de precipitació "${meteorNeuSobreTerraEntre18i24h.nom}" entre les 18 i les 24h al grup "Temps passat".`;

export const MSG_SI_PEDRA_ALESHORES_DIAMETRE_DE_PEDRA_ENTRE_00_I_07H = `Si se selecciona el meteor de precipitació "${meteorPedraEntre00i07h.nom}" entre les 00 i les 07h, cal informar la variable "${NOM_DIAMETRE_DE_LA_PEDRA_ENTRE_00_I_07H}".`;
export const MSG_SI_PEDRA_ALESHORES_DIAMETRE_DE_PEDRA_ENTRE_07_I_13H = `Si se selecciona el meteor de precipitació "${meteorPedraEntre07i13h.nom}" entre les 07 i les 13h, cal informar la variable "${NOM_DIAMETRE_DE_LA_PEDRA_ENTRE_07_I_13H}".`;
export const MSG_SI_PEDRA_ALESHORES_DIAMETRE_DE_PEDRA_ENTRE_13_I_18H = `Si se selecciona el meteor de precipitació "${meteorPedraEntre13i18h.nom}" entre les 13 i les 18h, cal informar la variable "${NOM_DIAMETRE_DE_LA_PEDRA_ENTRE_13_I_18H}".`;
export const MSG_SI_PEDRA_ALESHORES_DIAMETRE_DE_PEDRA_ENTRE_18_I_24H = `Si se selecciona el meteor de precipitació "${meteorPedraEntre18i24h.nom}" entre les 18 i les 24h, cal informar la variable "${NOM_DIAMETRE_DE_LA_PEDRA_ENTRE_18_I_24H}".`;

export const MSG_SI_DIAMETRE_DE_PEDRA_ALESHORES_PEDRA_ENTRE_00_I_07H = `Si s'informa la variable "${NOM_DIAMETRE_DE_LA_PEDRA_ENTRE_00_I_07H}", cal informar el meteor de precipitació "${meteorPedraEntre00i07h.nom}" entre les 00 i les 07h.`;
export const MSG_SI_DIAMETRE_DE_PEDRA_ALESHORES_PEDRA_ENTRE_07_I_13H = `Si s'informa la variable "${NOM_DIAMETRE_DE_LA_PEDRA_ENTRE_07_I_13H}", cal informar el meteor de precipitació "${meteorPedraEntre07i13h.nom}" entre les 07 i les 13h.`;
export const MSG_SI_DIAMETRE_DE_PEDRA_ALESHORES_PEDRA_ENTRE_13_I_18H = `Si s'informa la variable "${NOM_DIAMETRE_DE_LA_PEDRA_ENTRE_13_I_18H}", cal informar el meteor de precipitació "${meteorPedraEntre13i18h.nom}" entre les 13 i les 18h.`;
export const MSG_SI_DIAMETRE_DE_PEDRA_ALESHORES_PEDRA_ENTRE_18_I_24H = `Si s'informa la variable "${NOM_DIAMETRE_DE_LA_PEDRA_ENTRE_18_I_24H}", cal informar el meteor de precipitació "${meteorPedraEntre18i24h.nom}" entre les 18 i les 24h.`;

/*
 * Funcions que avaluen si es compleix la condició per afegir l'error
 ***/
const checkSiNeuSobreTerraAleshoresGruixDeNeu = (meteorsDePrecipitacioObservatsValor, gruixDeNeuAlTerraValor, valorMeteorNeuSobreTerraEnLaFranja) => {
    const neuSobreTerraEstaSeleccionat = Array.isArray(meteorsDePrecipitacioObservatsValor) && meteorsDePrecipitacioObservatsValor.indexOf(valorMeteorNeuSobreTerraEnLaFranja) >= 0;
    return (neuSobreTerraEstaSeleccionat && !gruixDeNeuAlTerraValor) && !(!neuSobreTerraEstaSeleccionat && gruixDeNeuAlTerraValor);
};

const checkSiGruixDeNeuAleshoresNeuSobreTerra = (meteorsDePrecipitacioObservatsValor, gruixDeNeuAlTerraValor, valorMeteorNeuSobreTerraEnLaFranja) => {
    const neuSobreTerraEstaSeleccionat = Array.isArray(meteorsDePrecipitacioObservatsValor) && meteorsDePrecipitacioObservatsValor.indexOf(valorMeteorNeuSobreTerraEnLaFranja) >= 0;
    return !(neuSobreTerraEstaSeleccionat && !gruixDeNeuAlTerraValor) && (!neuSobreTerraEstaSeleccionat && gruixDeNeuAlTerraValor);
};

const checkSiPedraAleshoresDiametreDePedra = (meteorsDePrecipitacioObservatsValor, gruixDeNeuAlTerraValor, valorMeteorPedraEnLaFranja) => {
    const neuSobreTerraEstaSeleccionat = Array.isArray(meteorsDePrecipitacioObservatsValor) && meteorsDePrecipitacioObservatsValor.indexOf(valorMeteorPedraEnLaFranja) >= 0;
    const gruixDeNeuAlTerraInformat = gruixDeNeuAlTerraValor === 0 || gruixDeNeuAlTerraValor;
    return (neuSobreTerraEstaSeleccionat && !gruixDeNeuAlTerraInformat) && !(!neuSobreTerraEstaSeleccionat && gruixDeNeuAlTerraInformat);
};

const checkSiDiametreDePedraAleshoresPedra = (meteorsDePrecipitacioObservatsValor, gruixDeNeuAlTerraValor, valorMeteorPedraEnLaFranja) => {
    const neuSobreTerraEstaSeleccionat = Array.isArray(meteorsDePrecipitacioObservatsValor) && meteorsDePrecipitacioObservatsValor.indexOf(valorMeteorPedraEnLaFranja) >= 0;
    const gruixDeNeuAlTerraInformat = gruixDeNeuAlTerraValor === 0 || gruixDeNeuAlTerraValor;
    return !(neuSobreTerraEstaSeleccionat && !gruixDeNeuAlTerraInformat) && (!neuSobreTerraEstaSeleccionat && gruixDeNeuAlTerraInformat);
};

/*
 * Grup Temps passat
 ***/
export const checkGrupTempsPassatINeu = (nouVariables) => {

    /*
     * Variables
     ***/
    // Variables de 00 a 07h
    const meteorsDePrecipitacioObservatsEntre00i07h = obteVariable(ID_METEORS_DE_PRECIPITACIO_OBSERVATS_ENTRE_00_I_07H, nouVariables);
    const gruixDeNeuAlTerraEntre00i07h = obteVariable(ID_GRUIX_DE_NEU_AL_TERRA_ENTRE_00_I_07H, nouVariables);
    const diametreDeLaPedraEntre00i07h = obteVariable(ID_DIAMETRE_DE_LA_PEDRA_ENTRE_00_I_07H, nouVariables);

    // Variables de 07 a 13h
    const meteorsDePrecipitacioObservatsEntre07i13h = obteVariable(ID_METEORS_DE_PRECIPITACIO_OBSERVATS_ENTRE_07_I_13H, nouVariables);
    const gruixDeNeuAlTerraEntre07i13h = obteVariable(ID_GRUIX_DE_NEU_AL_TERRA_ENTRE_07_I_13H, nouVariables);
    const diametreDeLaPedraEntre07i13h = obteVariable(ID_DIAMETRE_DE_LA_PEDRA_ENTRE_07_I_13H, nouVariables);

    // Variables de 13 a 18h
    const meteorsDePrecipitacioObservatsEntre13i18h = obteVariable(ID_METEORS_DE_PRECIPITACIO_OBSERVATS_ENTRE_13_I_18H, nouVariables);
    const gruixDeNeuAlTerraEntre13i18h = obteVariable(ID_GRUIX_DE_NEU_AL_TERRA_ENTRE_13_I_18H, nouVariables);
    const diametreDeLaPedraEntre13i18h = obteVariable(ID_DIAMETRE_DE_LA_PEDRA_ENTRE_13_I_18H, nouVariables);

    // Variables de 18 a 24h
    const meteorsDePrecipitacioObservatsEntre18i24h = obteVariable(ID_METEORS_DE_PRECIPITACIO_OBSERVATS_ENTRE_18_I_24H, nouVariables);
    const gruixDeNeuAlTerraEntre18i24h = obteVariable(ID_GRUIX_DE_NEU_AL_TERRA_ENTRE_18_I_24H, nouVariables);
    const diametreDeLaPedraEntre18i24h = obteVariable(ID_DIAMETRE_DE_LA_PEDRA_ENTRE_18_I_24H, nouVariables);

    /*
     * Valors de variables
     ***/
    // Valors de variables de 00 a 07h
    const meteorsDePrecipitacioObservatsEntre00i07hValor = obteValorVariable(meteorsDePrecipitacioObservatsEntre00i07h);
    const gruixDeNeuAlTerraEntre00i07hValor = obteValorVariable(gruixDeNeuAlTerraEntre00i07h);
    const diametreDeLaPedraEntre00i07hValor = obteValorVariable(diametreDeLaPedraEntre00i07h);

    // Valors de variables de 07 a 13h
    const meteorsDePrecipitacioObservatsEntre07i13hValor = obteValorVariable(meteorsDePrecipitacioObservatsEntre07i13h);
    const gruixDeNeuAlTerraEntre07i13hValor = obteValorVariable(gruixDeNeuAlTerraEntre07i13h);
    const diametreDeLaPedraEntre07i13hValor = obteValorVariable(diametreDeLaPedraEntre07i13h);

    // Valors de variables de 13 a 18h
    const meteorsDePrecipitacioObservatsEntre13i18hValor = obteValorVariable(meteorsDePrecipitacioObservatsEntre13i18h);
    const gruixDeNeuAlTerraEntre13i18hValor = obteValorVariable(gruixDeNeuAlTerraEntre13i18h);
    const diametreDeLaPedraEntre13i18hValor = obteValorVariable(diametreDeLaPedraEntre13i18h);

    // Valors de variables de 18 a 24h
    const meteorsDePrecipitacioObservatsEntre18i24hValor = obteValorVariable(meteorsDePrecipitacioObservatsEntre18i24h);
    const gruixDeNeuAlTerraEntre18i24hValor = obteValorVariable(gruixDeNeuAlTerraEntre18i24h);
    const diametreDeLaPedraEntre18i24hValor = obteValorVariable(diametreDeLaPedraEntre18i24h);

    /*
     * Arrais auxiliars per les diferents franjes horaries
     ***/
    // Arrais de diferents variables
    const llistaMeteorsDePrecipitacioObservats = [meteorsDePrecipitacioObservatsEntre00i07h, meteorsDePrecipitacioObservatsEntre07i13h, meteorsDePrecipitacioObservatsEntre13i18h, meteorsDePrecipitacioObservatsEntre18i24h];
    const llistaGruixDeNeuAlTerra = [gruixDeNeuAlTerraEntre00i07h, gruixDeNeuAlTerraEntre07i13h, gruixDeNeuAlTerraEntre13i18h, gruixDeNeuAlTerraEntre18i24h];
    const llistaDiametreDeLaPedra = [diametreDeLaPedraEntre00i07h, diametreDeLaPedraEntre07i13h, diametreDeLaPedraEntre13i18h, diametreDeLaPedraEntre18i24h];

    // Arrais de diferents valors de variables
    const llistaMeteorsDePrecipitacioObservatsValor = [meteorsDePrecipitacioObservatsEntre00i07hValor, meteorsDePrecipitacioObservatsEntre07i13hValor, meteorsDePrecipitacioObservatsEntre13i18hValor, meteorsDePrecipitacioObservatsEntre18i24hValor];
    const llistaGruixDeNeuAlTerraValor = [gruixDeNeuAlTerraEntre00i07hValor, gruixDeNeuAlTerraEntre07i13hValor, gruixDeNeuAlTerraEntre13i18hValor, gruixDeNeuAlTerraEntre18i24hValor];
    const llistaDiametreDeLaPedraValor = [diametreDeLaPedraEntre00i07hValor, diametreDeLaPedraEntre07i13hValor, diametreDeLaPedraEntre13i18hValor, diametreDeLaPedraEntre18i24hValor];

    // Arrais de diferents missatges:
    const llistaMissatgesNeuSobreElTerraINoGruix = [
        MSG_SI_NEU_SOBRE_TERRA_ALESHORES_GRUIX_DE_NEU_ENTRE_00_I_07H,
        MSG_SI_NEU_SOBRE_TERRA_ALESHORES_GRUIX_DE_NEU_ENTRE_07_I_13H,
        MSG_SI_NEU_SOBRE_TERRA_ALESHORES_GRUIX_DE_NEU_ENTRE_13_I_18H,
        MSG_SI_NEU_SOBRE_TERRA_ALESHORES_GRUIX_DE_NEU_ENTRE_18_I_24H
    ];

    const llistaMissatgesGruixDeNeuINoNeuSobreElTerra = [
        MSG_SI_GRUIX_DE_NEU_ALESHORES_NEU_SOBRE_TERRA_ENTRE_00_I_07H,
        MSG_SI_GRUIX_DE_NEU_ALESHORES_NEU_SOBRE_TERRA_ENTRE_07_I_13H,
        MSG_SI_GRUIX_DE_NEU_ALESHORES_NEU_SOBRE_TERRA_ENTRE_13_I_18H,
        MSG_SI_GRUIX_DE_NEU_ALESHORES_NEU_SOBRE_TERRA_ENTRE_18_I_24H
    ];

    const llistaMissatgesPedraINoDiametre = [
        MSG_SI_PEDRA_ALESHORES_DIAMETRE_DE_PEDRA_ENTRE_00_I_07H,
        MSG_SI_PEDRA_ALESHORES_DIAMETRE_DE_PEDRA_ENTRE_07_I_13H,
        MSG_SI_PEDRA_ALESHORES_DIAMETRE_DE_PEDRA_ENTRE_13_I_18H,
        MSG_SI_PEDRA_ALESHORES_DIAMETRE_DE_PEDRA_ENTRE_18_I_24H
    ];

    const llistaMissatgesDiametreDePedraINoPedra = [
        MSG_SI_DIAMETRE_DE_PEDRA_ALESHORES_PEDRA_ENTRE_00_I_07H,
        MSG_SI_DIAMETRE_DE_PEDRA_ALESHORES_PEDRA_ENTRE_07_I_13H,
        MSG_SI_DIAMETRE_DE_PEDRA_ALESHORES_PEDRA_ENTRE_13_I_18H,
        MSG_SI_DIAMETRE_DE_PEDRA_ALESHORES_PEDRA_ENTRE_18_I_24H
    ];

    const llistaMeteorNeuSobreTerraSegonsFranja = [meteorNeuSobreTerraEntre00i07h, meteorNeuSobreTerraEntre07i13h, meteorNeuSobreTerraEntre13i18h, meteorNeuSobreTerraEntre18i24h];
    const llistaMeteorPedraSegonsFranja = [meteorPedraEntre00i07h, meteorPedraEntre07i13h, meteorPedraEntre13i18h, meteorPedraEntre18i24h];

    // Recorrem cadascun dels periodes
    for (let indexFranjaHoraria = 0; indexFranjaHoraria < llistaMeteorsDePrecipitacioObservats.length; indexFranjaHoraria++) {

        // Agafem les variables del periode
        let gruixDeNeuAlTerra = llistaGruixDeNeuAlTerra[indexFranjaHoraria];
        let diametreDeLaPedra = llistaDiametreDeLaPedra[indexFranjaHoraria];

        // Agafem els valors de les variables del periode
        let meteorsDePrecipitacioObservats = llistaMeteorsDePrecipitacioObservats[indexFranjaHoraria];
        let meteorsDePrecipitacioObservatsValor = llistaMeteorsDePrecipitacioObservatsValor[indexFranjaHoraria];
        let gruixDeNeuAlTerraValor = llistaGruixDeNeuAlTerraValor[indexFranjaHoraria];
        let diametreDeLaPedraValor = llistaDiametreDeLaPedraValor[indexFranjaHoraria];

        // Agafem els missatges
        const missatgeNeuSobreElTerraINoGruix = llistaMissatgesNeuSobreElTerraINoGruix[indexFranjaHoraria];
        const missatgeGruixDeNeuINoNeuSobreElTerra = llistaMissatgesGruixDeNeuINoNeuSobreElTerra[indexFranjaHoraria];
        const missatgePedraINoDiametre = llistaMissatgesPedraINoDiametre[indexFranjaHoraria];
        const missatgeDiametreDePedraINoPedra = llistaMissatgesDiametreDePedraINoPedra[indexFranjaHoraria];

        // Valors dels meteors observats segons la franja
        const meteorNeuSobreTerra = llistaMeteorNeuSobreTerraSegonsFranja[indexFranjaHoraria];
        const meteorPedra = llistaMeteorPedraSegonsFranja[indexFranjaHoraria];

        if (gruixDeNeuAlTerra && meteorsDePrecipitacioObservats) {

            //Si se selecciona el meteor de precipitació "Neu sobre terra (Nt)" entre les 00 i les 07h al grup "Temps passat", cal informar la variable "Gruix de neu al terra entre 00 i 07h" al grup "Neu".
            if (checkSiNeuSobreTerraAleshoresGruixDeNeu(meteorsDePrecipitacioObservatsValor, gruixDeNeuAlTerraValor, meteorNeuSobreTerra.valor)) {
                afegeixErrorAVariable(gruixDeNeuAlTerra, missatgeNeuSobreElTerraINoGruix);
                afegeixErrorAVariable(meteorsDePrecipitacioObservats, missatgeNeuSobreElTerraINoGruix);
            }

            //Si s'informa la variable "Gruix de neu al terra entre 00 i 07h" al grup "Neu", cal informar el meteor de precipitació "Neu sobre terra (Nt)" entre les 00 i les 07h al grup "Temps passat".`;
            if (checkSiGruixDeNeuAleshoresNeuSobreTerra(meteorsDePrecipitacioObservatsValor, gruixDeNeuAlTerraValor, meteorNeuSobreTerra.valor)) {
                afegeixErrorAVariable(gruixDeNeuAlTerra, missatgeGruixDeNeuINoNeuSobreElTerra);
                afegeixErrorAVariable(meteorsDePrecipitacioObservats, missatgeGruixDeNeuINoNeuSobreElTerra);
            }
        }

        if (diametreDeLaPedra && meteorsDePrecipitacioObservats) {

            //Si se selecciona el meteor de precipitació "Pedra (Pd)" entre les 00 i les 07h, cal informar la variable "Diàmetre de la pedra entre 00 i 07h".`;
            if (checkSiPedraAleshoresDiametreDePedra(meteorsDePrecipitacioObservatsValor, diametreDeLaPedraValor, meteorPedra.valor)) {
                afegeixErrorAVariable(diametreDeLaPedra, missatgePedraINoDiametre);
                afegeixErrorAVariable(meteorsDePrecipitacioObservats, missatgePedraINoDiametre);
            }

            //Si s'informa la variable "Diàmetre de la pedra entre 00 i 07h", cal informar el meteor de precipitació "Pedra (Pd)" entre les 00 i les 07h.`;
            if (checkSiDiametreDePedraAleshoresPedra(meteorsDePrecipitacioObservatsValor, diametreDeLaPedraValor, meteorPedra.valor)) {
                afegeixErrorAVariable(diametreDeLaPedra, missatgeDiametreDePedraINoPedra);
                afegeixErrorAVariable(meteorsDePrecipitacioObservats, missatgeDiametreDePedraINoPedra);
            }
        }
    }

};



// WEBPACK FOOTER //
// ./src/reducers/observacio/formulari/filtresCoherencia/grupsTempsPassatINeu.js